const CTA_UPDATE = 'UPDATE';
const CTA_PAY_NOW = 'PAY NOW';
const CTA_APPLY_COUPON = 'APPLY';

export { CTA_UPDATE, CTA_PAY_NOW, CTA_APPLY_COUPON };
